import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { CheckoutStatusType } from 'types/checkout'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { setCheckoutUnsubscribesAction } from 'reducks/checkout/actions'
import { CheckoutItemType } from 'types/checkoutItem'
import { fetchCheckoutItemsByRef, mergeListeningCheckoutWithItems } from 'reducks/checkout/operations'

const fetchPreparingDeliveryOrders = (status: CheckoutStatusType[], storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // unsubscribeがセットされている状態（リスナーがONの状態）であれば処理しない
    if (getState().checkout.is_set_unsubscribe) return
    dispatch(showLoadingAction())
    // ステータスに応じてクエリを作成する
    const query = storeRef
      .collection('store_checkouts')
      .where('is_delivered', '==', false)
      .where('type', '==', 'delivery')
      .where('status', 'in', status)
    const unsubscribe = await query.onSnapshot(async (snapshots) => {
      const itemPromises: Promise<CheckoutItemType[]>[] = []
      // データの追加のみ監視する
      const changes = snapshots.docChanges().filter((change) => change.type === 'added')
      changes.forEach((change) => {
        itemPromises.push(fetchCheckoutItemsByRef(change.doc.ref, []))
      })
      const result = await Promise.all(itemPromises).catch((error) => {
        throw new Error(`注文商品の一括取得に失敗: ${error}`)
      })
      const items = result.reduce((prev, _items) => [...prev, ..._items], [])
      const currentOrders = getState().checkout.orders
      mergeListeningCheckoutWithItems(changes, items, currentOrders, dispatch, 'checkout_at', 'asc')
    })
    dispatch(setCheckoutUnsubscribesAction([unsubscribe]))
    dispatch(hideLoadingAction())
  }
}

export default fetchPreparingDeliveryOrders
